var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#009DDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#9097A5",
    strokeOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 30.5625L15.4366 23.4117C15.3524 23.3043 15.269 23.1962 15.1865 23.0875C14.1508 21.7232 13.5912 20.0567 13.5938 18.3438C13.5938 16.2469 14.4267 14.2359 15.9094 12.7532C17.3922 11.2705 19.4031 10.4375 21.5 10.4375C23.5969 10.4375 25.6079 11.2705 27.0906 12.7532C28.5733 14.2359 29.4063 16.2469 29.4063 18.3438C29.4088 20.0559 28.8495 21.7216 27.8142 23.0853L27.8135 23.0875C27.8135 23.0875 27.5979 23.3707 27.5655 23.4088L21.5 30.5625ZM16.3336 22.2214C16.3351 22.2214 16.5018 22.4428 16.5399 22.4902L21.5 28.3401L26.4666 22.4823C26.4982 22.4428 26.6664 22.22 26.6671 22.2192C27.5132 21.1046 27.9704 19.7432 27.9688 18.3438C27.9688 16.6281 27.2872 14.9828 26.0741 13.7697C24.861 12.5565 23.2156 11.875 21.5 11.875C19.7844 11.875 18.139 12.5565 16.9259 13.7697C15.7128 14.9828 15.0313 16.6281 15.0313 18.3438C15.0298 19.744 15.4875 21.1062 16.3344 22.2214H16.3336Z",
    fill: "#009DDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0938 21.9375H23.6562V16.1875H19.3438V21.9375H17.9062V16.1875C17.9066 15.8064 18.0582 15.441 18.3277 15.1715C18.5972 14.902 18.9626 14.7504 19.3438 14.75H23.6562C24.0374 14.7504 24.4028 14.902 24.6723 15.1715C24.9418 15.441 25.0934 15.8064 25.0938 16.1875V21.9375Z",
    fill: "#009DDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 20.5H22.2188V21.9375H20.7812V20.5ZM20.7812 17.625H22.2188V19.0625H20.7812V17.625Z",
    fill: "#009DDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchWidgetIcon);
export default __webpack_public_path__ + "static/media/branch-widget-icon.be2aae8f1d3debda671a91da634e4ee6.svg";
export { ForwardRef as ReactComponent };